import React from 'react';
import { BadgeStyled } from './BadgeStyled';

function Badge() {
  
  return (
    <BadgeStyled>
      <div className='badge-title'>myAster Exclusive</div>
    </BadgeStyled>
  );
}

export default Badge;
Badge.propTypes = {};
